import { reportEnterRoomChannelTiming } from '@/api/report';

class TimingCollector {
  constructor() {
    this.curTask = {
      start_time: null,
      enter_room_time: null,
      enter_channel_time: null,
      enter_rtc_time: null,
      has_default_channel: null,
    };
  }

  // 更新当前收集任务的状态信息
  update(type, options = {}) {
    switch (type) {
      case 'start':
        const diffs = this._calculateTimeDiffs();
        if (Object.keys(diffs).length > 0) {
          // 检查计算出的差值是否都合法（非负数），只有都合法时才进行上报和后续操作
          this.done(this._filterInvalidData(diffs));
        }
        this.curTask.start_time = Date.now();
      case 'enter_room':
        this.curTask.enter_room_time = Date.now();
        this.curTask.has_default_channel = options.has_default_channel
        break;
      case 'enter_channel_success':
        this.curTask.enter_channel_time = Date.now();
        break;
      case 'enter_rtc_success':
        this.curTask.enter_rtc_time = Date.now();
        break;
      default:
        break;
    }
  }

  done(data) {
    try {
      if(this.curTask.has_default_channel !== null && this.curTask.enter_room_time !== undefined){
        data['has_default_channel'] = this.curTask.has_default_channel;
      }
      reportEnterRoomChannelTiming(data);
      this.curTask = {
        start_time: null,
        enter_room_time: null,
        enter_channel_time: null,
        enter_rtc_time: null,
        has_default_channel: null,
      };
    } catch (error) {
      console.log(error);
    }
  }

  _calculateTimeDiffs() {
    const diffs = {};
    if (this.curTask.start_time && this.curTask.enter_room_time) {
      diffs.enter_room_consume =
        this.curTask.enter_room_time - this.curTask.start_time;
    }
    if (this.curTask.enter_room_time && this.curTask.enter_channel_time) {
      diffs.enter_channel_consume =
        this.curTask.enter_channel_time - this.curTask.enter_room_time;
    }
    if (this.curTask.enter_channel_time && this.curTask.enter_rtc_time) {
      diffs.enter_rtc_consume =
        this.curTask.enter_rtc_time - this.curTask.enter_channel_time;
    }
    return diffs;
  }

  _filterInvalidData(diffs) {
    const validDiffs = {};
    for (const key in diffs) {
      if (diffs[key] >= 0) {
        validDiffs[key] = diffs[key];
      }
    }
    return validDiffs;
  }
}

const timingCollector = new TimingCollector();

export default timingCollector;
